export default __webpack_public_path__ + "static/media/password.875512a3.jpg";